/**
 * @fileoverview Initial state for the Flow Editor module.
 * @module store/modules/floweditor/state
 */

import { FlowEditorState } from "./types";

/**
 * Initial state for flow editor.
 *
 * @type {FlowEditorState}
 */
const state: FlowEditorState = {
  flows: {},
  fetchingFlows: false,
  contents: {},
  triggers: {},
};

export default state;
